var _style, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B4CCDD;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,16.5c-5.5,0-9.9,4.4-9.9,9.9c0,2.7,1.1,5.1,2.8,6.9l0,0l0.1,0.1c0,0,0,0,0,0l5.6,5.6h0 c0.4,0.3,0.8,0.5,1.4,0.5c0.5,0,1-0.2,1.4-0.5h0l5.3-5.3c2-1.8,3.2-4.4,3.2-7.3C34.9,20.9,30.5,16.5,25,16.5z M25.9,37.9h-1.8 c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h1.8c0.5,0,0.9,0.4,0.9,0.9C26.8,37.5,26.4,37.9,25.9,37.9z M25,34.8 c-4.6,0-8.4-3.8-8.4-8.4c0-4.6,3.8-8.4,8.4-8.4s8.4,3.8,8.4,8.4C33.4,31,29.6,34.8,25,34.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25,
    cy: 26.4,
    r: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenDefault);
export default __webpack_public_path__ + "static/media/token-default.88a0ac134d0144b6bc5d5d3b9d7c3425.svg";
export { ForwardRef as ReactComponent };